import { useParams } from "react-router-dom";
import { Container, Input, Back, Loading } from "../../components";
import AddImages from "../../components/AddImage/AddImages";
import { useEffect } from "react";
import { fileUrl, handleClick, useFETCH, usePOST } from "../../APIs/useMyAPI";

function AddNews() {
  const { id } = useParams();
  const {
    formData,
    handleChange,
    loading,
    error,
    handleSubmit,
    setFormData,
    img,
    setImg,
  } = usePOST({});
  const handleFormSubmit = (event) => {
    event.preventDefault();
    handleSubmit(isNaN(id) ? "news" : `news/${id}`);
  };
  const { data } = useFETCH(`news/${id}`);
  let dataUp = data?.data.data;
  useEffect(() => {
    !isNaN(id) &&
      setFormData({
        name: dataUp?.name,
        description: dataUp?.description,
      });
  }, [dataUp]);
  return (
    <Container>
      {loading ? <Loading /> : ""}
      <div className="flex flex-col">
        <div className="w-[50%] max-sm:w-[80%] mx-auto mt-8 space-y-5">
          <Input
            title="Add  Name"
            onChange={handleChange}
            name="name"
            value={formData.name}
          />
          <textarea
            type="text"
            onChange={handleChange}
            value={formData.description}
            name="description"
            className="text-Gray font-semibold px-2 outline-none border-2 border-Brown rounded-xl h-[150px] w-[100%]"
            placeholder="Add Description "
          />
        </div>
        <div className="mt-8">
          <AddImages
            onChange={handleChange}
            name="image"
            image={"Add Photo"}
          ></AddImages>
        </div>
        <div className="flex justify-center space-x-3 mt-6">
          {img && (
            <div className="relative">
              <div
                onClick={() => {
                  setImg("");
                  setFormData("");
                }}
                className="bg-red-600 text-white w-5 h-5 rounded-full absolute -top-2 -left-1 z-10 flex cursor-pointer items-center justify-center "
              >
                X
              </div>
              <img
                onClick={handleClick}
                className="w-[300px] h-[220px] mx-auto rounded-2xl mb-6"
                src={img}
                alt=""
              />
            </div>
          )}
          {isNaN(id) ? (
            ""
          ) : (
            <div className="relative">
              <img
                onClick={handleClick}
                className="w-[300px] h-[220px] mx-auto rounded-2xl mb-6"
                src={fileUrl + dataUp?.image}
                alt=""
              />
            </div>
          )}
        </div>
      </div>
      <div className="text-red-500 font-semibold ">{error}</div>
      <Back onClick={handleFormSubmit}>Save</Back>
    </Container>
  );
}
export default AddNews;
